import { memo } from 'react';
import { Alert, Typography } from 'antd';
import { Auction } from 'models/auction/Auction';
import styles from './InvitationCode.module.css';

interface InvitationCodeProps {
  auction: Auction;
}

function InvitationCode({ auction }: InvitationCodeProps) {
  const { invitation_code } = auction;
  return (
    invitation_code && (
      <Alert
        className={styles.alert}
        message={
          <Typography.Text copyable={{ text: invitation_code, tooltips: ['복사', '복사됨'] }}>
            초대코드를 복사해 공유해주세요!
          </Typography.Text>
        }
        type="info"
        showIcon
      />
    )
  );
}

export default memo(InvitationCode);
